module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [(this.loadPage) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "billNumber"
    }
  }, [_vm._v("Bill Number")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "options": _vm.billNumberList,
      "optionLabel": "billPrefix",
      "filterMatchMode": "contains",
      "placeholder": "Select bill no",
      "id": "billNumber"
    },
    model: {
      value: (_vm.billPrefix),
      callback: function($$v) {
        _vm.billPrefix = $$v
      },
      expression: "billPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": _vm.searchInventoryDetailsByBillNo
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!this.loadPage) ? _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "returnDate"
    }
  }, [_vm._v("Return Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.returnDate),
      callback: function($$v) {
        _vm.returnDate = $$v
      },
      expression: "returnDate"
    }
  }) : _c('InputMask', {
    ref: "tran",
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "id": "returnDate"
    },
    model: {
      value: (_vm.returnDate),
      callback: function($$v) {
        _vm.returnDate = $$v
      },
      expression: "returnDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "purchaseSalesDate"
    }
  }, [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format",
      "disabled": ""
    },
    model: {
      value: (_vm.salesDate),
      callback: function($$v) {
        _vm.salesDate = $$v
      },
      expression: "salesDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "id": "purchaseSalesDate",
      "disabled": ""
    },
    model: {
      value: (_vm.salesDate),
      callback: function($$v) {
        _vm.salesDate = $$v
      },
      expression: "salesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "billPrefix"
    }
  }, [_vm._v("Bill Prefix")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "billPrefix",
      "disabled": ""
    },
    model: {
      value: (_vm.billPrefix),
      callback: function($$v) {
        _vm.billPrefix = $$v
      },
      expression: "billPrefix"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "payMethod"
    }
  }, [_vm._v("Payment Method")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "payMethod",
      "disabled": ""
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Contact Number: " + _vm._s(_vm.contactNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Bill Prefix: " + _vm._s(_vm.customerName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.childSalesDetailsDTOList), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quantity - _vm.returnQty))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('InputNumber', {
      attrs: {
        "onfocus": "if (this.value === '0'){this.value = ''}"
      },
      on: {
        "change": function($event) {
          return _vm.updateInventoryDetails(item.id, index)
        }
      },
      model: {
        value: (_vm.returnQty),
        callback: function($$v) {
          _vm.returnQty = $$v
        },
        expression: "returnQty"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.sellingPrice))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.sellingPrice * item.quantity))])])])
  })], 2)]), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "narration"
    }
  }, [_vm._v("Return Reason")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "narration",
      "rows": "6"
    },
    model: {
      value: (_vm.returnReason),
      callback: function($$v) {
        _vm.returnReason = $$v
      },
      expression: "returnReason"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": "Save"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addSalesReturnBillWise.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.goBack
    }
  })], 1)])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Item Name")]), _vm._v(" "), _c('th', [_vm._v("Purchased Qty")]), _vm._v(" "), _c('th', [_vm._v("Remaining Qty")]), _vm._v(" "), _c('th', [_vm._v("Return Qty")]), _vm._v(" "), _c('th', [_vm._v("Rate")]), _vm._v(" "), _c('th', [_vm._v("Amount")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e48c6be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/posSalesReturnBillwise.vue
// module id = 2170
// module chunks = 0